export const SIDES = 'Sides'

// Limits
export const MAX_PRODUCTS_PER_BOX = 10

export const LimitType = {
  Box: 'box',
  Item: 'item',
  Category: 'category',
}
